module.exports = __webpack_public_path__ + "files/4747c408226c2454e79bb97098a16415.png";